import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const publicAlwaysAccessible = ["/login", "/signup", "/forgot-password", "/reset-password"];

const userRestrictedPaths = [
  "/reports",
  "/admin-insights",
  "/service-ratings",
  "/moments",
  "/internal-notifications",
  "/announcements",
  "/settings",
  "/companies"
];

const resolveDefaultPrivatePath = user => {
  if (user?.profile === "user") {
    return user?.showDashboard === "enabled" ? "/" : "/tickets";
  }

  return "/";
};

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
  const { isAuth, loading, user } = useContext(AuthContext);
  const routePath = String(rest.path || "");

  if (loading) {
    return <BackdropLoading />;
  }

  if (!isAuth && isPrivate) {
    return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
  }

  if (isAuth && !isPrivate && !publicAlwaysAccessible.includes(rest.path)) {
    return <Redirect to={{ pathname: resolveDefaultPrivatePath(user), state: { from: rest.location } }} />;
  }

  if (isAuth && user?.profile === "user") {
    if (routePath === "/" && user?.showDashboard === "disabled") {
      return <Redirect to={{ pathname: "/tickets", state: { from: rest.location } }} />;
    }

    if (userRestrictedPaths.includes(routePath)) {
      return <Redirect to={{ pathname: resolveDefaultPrivatePath(user), state: { from: rest.location } }} />;
    }
  }

  return <RouterRoute {...rest} component={Component} />;
};

export default Route;
